var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("a", { staticClass: "icon-close", attrs: { href: "#" } }),
    _vm._v(" "),
    _vm.hasRole("admin") || _vm.hasRole("demo") || _vm.hasRole("tester")
      ? _c(
          "ul",
          { class: _vm.is_open ? "show" : "", attrs: { id: "sidebarnav" } },
          [
            _vm._m(0),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("demo")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-11",
                        attrs: {
                          "active-class": "active",
                          to: "/account/user",
                        },
                      },
                      [_vm._v("General Partners")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("demo")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-11",
                        attrs: {
                          "active-class": "active",
                          to: "/account/investors",
                        },
                      },
                      [_vm._v("Limited Partners")]
                    ),
                    _vm._v(" "),
                    _c("ul", [
                      (_vm.hasPermission("list-user") || _vm.hasRole("demo")) &&
                      _vm.getConfig("show_user_menu")
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    "active-class": "active",
                                    to: "/account/investor-contacts",
                                  },
                                },
                                [_vm._v("People")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.hasPermission("list-user") || _vm.hasRole("demo")) &&
                      _vm.getConfig("show_user_menu")
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    "active-class": "active",
                                    to: "/account/investor-callcenter",
                                  },
                                },
                                [_vm._v("Callcenter")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("demo")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-14",
                        attrs: {
                          "active-class": "active",
                          to: "/account/deals",
                        },
                      },
                      [_vm._v("Deals Section")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("demo")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    staticStyle: { "margin-top": "20px" },
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-12",
                        attrs: {
                          "active-class": "active",
                          to: "/account/transcripts",
                        },
                      },
                      [_vm._v("Transcripts")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("demo")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    staticStyle: { "margin-top": "20px" },
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "icon-13",
                        attrs: { href: "/account/transcripts" },
                      },
                      [_vm._v("AI Features")]
                    ),
                    _vm._v(" "),
                    _c("ul", [
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/recommender",
                              },
                            },
                            [_vm._v("AI Recommender")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/data-notes",
                              },
                            },
                            [_vm._v("AI Data & Notes")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/email-data",
                              },
                            },
                            [_vm._v("AI Email Data")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/marketing-docs",
                              },
                            },
                            [_vm._v("AI Marketing Docs")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("demo")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    staticStyle: { "margin-top": "20px" },
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-8",
                        attrs: {
                          "active-class": "active",
                          to: "/account/email-template",
                        },
                      },
                      [_vm._v("E-Mail Templates")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        )
      : _vm.hasRole("editor")
      ? _c(
          "ul",
          { class: _vm.is_open ? "show" : "", attrs: { id: "sidebarnav" } },
          [
            _vm._m(1),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("editor")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-11",
                        attrs: {
                          "active-class": "active",
                          to: "/account/investors",
                        },
                      },
                      [_vm._v("Limited Partners")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("editor")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          "active-class": "active",
                          to: "/account/investor-contacts",
                        },
                      },
                      [_vm._v("  - People")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("editor")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          "active-class": "active",
                          to: "/account/investor-callcenter",
                        },
                      },
                      [_vm._v("  - Callcenter")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("editor")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-14",
                        attrs: {
                          "active-class": "active",
                          to: "/account/deals",
                        },
                      },
                      [_vm._v("Deals Section")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("editor")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    staticStyle: { "margin-top": "20px" },
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-12",
                        attrs: {
                          "active-class": "active",
                          to: "/account/transcripts",
                        },
                      },
                      [_vm._v("Transcripts")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("editor")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    staticStyle: { "margin-top": "20px" },
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "icon-13",
                        attrs: { href: "/account/transcripts" },
                      },
                      [_vm._v("AI Features")]
                    ),
                    _vm._v(" "),
                    _c("ul", [
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/recommender",
                              },
                            },
                            [_vm._v("AI Recommender")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/data-notes",
                              },
                            },
                            [_vm._v("AI Data & Notes")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/email-data",
                              },
                            },
                            [_vm._v("AI Email Data")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/marketing-docs",
                              },
                            },
                            [_vm._v("AI Marketing Docs")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("editor")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    staticStyle: { "margin-top": "20px" },
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-8",
                        attrs: {
                          "active-class": "active",
                          to: "/account/email-template",
                        },
                      },
                      [_vm._v("E-Mail Templates")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        )
      : _vm.hasRole("sales")
      ? _c(
          "ul",
          { class: _vm.is_open ? "show" : "", attrs: { id: "sidebarnav" } },
          [
            _vm._m(2),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("sales")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-11",
                        attrs: {
                          "active-class": "active",
                          to: "/account/user",
                        },
                      },
                      [_vm._v("General Partners")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("sales")) &&
            _vm.getConfig("show_user_menu") &&
            _vm.getAuthUser("id") != 769
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-11",
                        attrs: {
                          "active-class": "active",
                          to: "/account/investors",
                        },
                      },
                      [_vm._v("Limited Partners")]
                    ),
                    _vm._v(" "),
                    _c("ul", [
                      (_vm.hasPermission("list-user") ||
                        _vm.hasRole("sales")) &&
                      _vm.getConfig("show_user_menu")
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    "active-class": "active",
                                    to: "/account/investor-contacts",
                                  },
                                },
                                [_vm._v("People")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.hasPermission("list-user") ||
                        _vm.hasRole("sales")) &&
                      _vm.getConfig("show_user_menu")
                        ? _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    "active-class": "active",
                                    to: "/account/investor-callcenter",
                                  },
                                },
                                [_vm._v("Callcenter")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("sales")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-14",
                        attrs: {
                          "active-class": "active",
                          to: "/account/deals",
                        },
                      },
                      [_vm._v("Deals Section")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("sales")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    staticStyle: { "margin-top": "20px" },
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-12",
                        attrs: {
                          "active-class": "active",
                          to: "/account/transcripts",
                        },
                      },
                      [_vm._v("Transcripts")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("sales")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    staticStyle: { "margin-top": "20px" },
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "icon-13",
                        attrs: { href: "/account/transcripts" },
                      },
                      [_vm._v("AI Features")]
                    ),
                    _vm._v(" "),
                    _c("ul", [
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/recommender",
                              },
                            },
                            [_vm._v("AI Recommender")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/data-notes",
                              },
                            },
                            [_vm._v("AI Data & Notes")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/email-data",
                              },
                            },
                            [_vm._v("AI Email Data")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                "active-class": "active",
                                to: "/account/ai-features/marketing-docs",
                              },
                            },
                            [_vm._v("AI Marketing Docs")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("sales")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  {
                    staticStyle: { "margin-top": "20px" },
                    on: {
                      click: function ($event) {
                        return _vm.hideMenu()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "icon-8",
                        attrs: {
                          "active-class": "active",
                          to: "/account/email-template",
                        },
                      },
                      [_vm._v("E-Mail Templates")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        )
      : _vm.hasRole("callcenter")
      ? _c(
          "ul",
          { class: _vm.is_open ? "show" : "", attrs: { id: "sidebarnav" } },
          [
            _vm._m(3),
            _vm._v(" "),
            (_vm.hasPermission("list-user") || _vm.hasRole("sales")) &&
            _vm.getConfig("show_user_menu")
              ? _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          "active-class": "active",
                          to: "/account/investor-callcenter",
                        },
                      },
                      [_vm._v("Phonelist")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        )
      : _c(
          "ul",
          { class: _vm.is_open ? "show" : "", attrs: { id: "sidebarnav" } },
          [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function ($event) {
                    return _vm.hideMenu()
                  },
                },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "icon-1",
                    attrs: {
                      "active-class": "active",
                      to: "/account/dashboard",
                      exact: "",
                    },
                  },
                  [_vm._v("Dashboard")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function ($event) {
                    return _vm.hideMenu()
                  },
                },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "icon-2",
                    attrs: {
                      "active-class": "active",
                      to: "/account/questionnaire",
                      exact: "",
                    },
                  },
                  [_vm._v("Questionnaire")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function ($event) {
                    return _vm.hideMenu()
                  },
                },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "icon-3",
                    attrs: {
                      "active-class": "active",
                      to: "/account/documents",
                      exact: "",
                    },
                  },
                  [_vm._v("Documents")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function ($event) {
                    return _vm.hideMenu()
                  },
                },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "icon-4",
                    attrs: {
                      "active-class": "active",
                      to: "/account/investor-analysis",
                      exact: "",
                    },
                  },
                  [_vm._v("Investor Analysis")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function ($event) {
                    return _vm.hideMenu()
                  },
                },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "icon-5",
                    attrs: {
                      "active-class": "active",
                      to: "/account/investor-selection",
                      exact: "",
                    },
                  },
                  [_vm._v("Investor Selection")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function ($event) {
                    return _vm.hideMenu()
                  },
                },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "icon-6",
                    attrs: {
                      "active-class": "active",
                      to: "/account/pipeline",
                      exact: "",
                    },
                  },
                  [_vm._v("Pipeline")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function ($event) {
                    return _vm.hideMenu()
                  },
                },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "icon-7",
                    attrs: {
                      "active-class": "active",
                      to: "/account/calendar",
                      exact: "",
                    },
                  },
                  [_vm._v("Calendar")]
                ),
              ],
              1
            ),
          ]
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("h3", [_vm._v("Administration")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("h3", [_vm._v("Administration")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("h3", [_vm._v("Administration")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("h3", [_vm._v("Callcenter")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("h3", [_vm._v("Main")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }